import { Component, Input } from '@angular/core';
import { PaymentData } from '../../../models/payment-data';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models';

@Component({
    selector: 'app-payment-data-display',
    templateUrl: './payment-data-display.component.html',
    standalone: false,
})
export class PaymentDataDisplayComponent extends OrderStepBaseComponent {
    @Input()
    public payment: Partial<PaymentData>;
    public constructor() {
        super();
    }

    public getData(): Partial<OrderState> {
        return {};
    }
}
